module.exports = __webpack_public_path__ + "img/map_2.a1da3294.png";